/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "../app/@shared/ui/modal/modal.component.ngfactory";
import * as i2 from "../app/@shared/ui/modal/modal.component";
import * as i3 from "../app/@shared/ui/modal/modal.service";
import * as i4 from "./compat-modals.component";
var styles_CompatModalsComponent = [];
var RenderType_CompatModalsComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_CompatModalsComponent, data: {} });
export { RenderType_CompatModalsComponent as RenderType_CompatModalsComponent };
export function View_CompatModalsComponent_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "fl-modal", [], [[2, "BackdropActive", null]], [[null, "click"], ["document", "keydown.escape"]], function (_v, en, $event) { var ad = true; if (("click" === en)) {
        var pd_0 = (i0.ɵnov(_v, 1).handleClick() !== false);
        ad = (pd_0 && ad);
    } if (("document:keydown.escape" === en)) {
        var pd_1 = (i0.ɵnov(_v, 1).handleEscape($event) !== false);
        ad = (pd_1 && ad);
    } return ad; }, i1.View_ModalComponent_0, i1.RenderType_ModalComponent)), i0.ɵdid(1, 245760, null, 0, i2.ModalComponent, [i3.ModalService, [1, i0.Injector]], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, function (_ck, _v) { var currVal_0 = i0.ɵnov(_v, 1).backdropActive; _ck(_v, 0, 0, currVal_0); }); }
export function View_CompatModalsComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "webapp-compat-modals", [], null, null, null, View_CompatModalsComponent_0, RenderType_CompatModalsComponent)), i0.ɵdid(1, 114688, null, 0, i4.CompatModalsComponent, [i3.ModalService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var CompatModalsComponentNgFactory = i0.ɵccf("webapp-compat-modals", i4.CompatModalsComponent, View_CompatModalsComponent_Host_0, {}, {}, []);
export { CompatModalsComponentNgFactory as CompatModalsComponentNgFactory };



// WEBPACK FOOTER //
// ./src/compat/compat-modals.component.ngfactory.js.pre-build-optimizer.js